import { schema } from 'normalizr';

const linkSchema = new schema.Entity('links', {
  //
});

export default linkSchema;
